<template>
  <button
    :class="classes"
    :data-clipboard-text="url"
    data-toggle="popover"
    data-trigger="manual"
    data-content="URL copied!"
    data-placement="top"
    @click.prevent=""
    type="button"
  >
    <i :class="`fa fa-fw fa-${icon} mr-1`"></i>
    <slot>Share</slot>
  </button>
</template>

<script>
// jQuery must be imported here or $.fn.popover won't work
import $ from 'jquery'
import ClipboardJS from 'clipboard'

export default {
  props: {
    url: {
      type: String,
      default () {
        return document.location.href
      }
    },
    value: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: 'share'
    },
    btnClass: {
      type: String,
      default: 'btn btn-sm btn-outline-dark btn-share'
    }
  },
  computed: {
    classes () {
      return this.btnClass + ' ' + this.uidClass + ' text-nowrap '
    },
    uidClass () {
      return 'share-button-' + this._uid
    }
  },
  mounted () {
    let clipboard = new ClipboardJS('.' + this.uidClass)

    clipboard.on('success', (e) => {
      $(this.$el).popover('show')
      $(this.$el).one('mouseout', () => {
        $(this.$el).popover('hide')
      })
    })
  }
}
</script>